import { ParsedUrlQuery } from 'querystring'
import { NextRouter } from 'next/router'

export const getUtmsFromQuery = (query: ParsedUrlQuery) => {
  const utms: ParsedUrlQuery = {}

  for (const item in query) {
    if (item.includes('utm') || item.includes('gclid')) utms[item] = query[item]
  }

  return utms
}

export const getUtmsFromSearchParams = (searchParams: URLSearchParams) => {
  const utms: { [k: string]: string } = {}

  searchParams.forEach((value, key) => {
    if (key.includes('utm') || key.includes('gclid')) utms[key] = value
  })

  return utms
}

export const makeUrlWithUtms = ({
  href,
  query,
  searchParams
}: {
  href: string
  query?: URLSearchParams
  searchParams: URLSearchParams | null
}) => {
  if (!searchParams) return href

  const utms = getUtmsFromSearchParams(searchParams)

  const queries = query
    ? `${query.toString()}&${new URLSearchParams(utms).toString()}`
    : new URLSearchParams(utms).toString()

  return queries ? `${href}?${queries}` : href
}

export const updateQueryParams = ({
  router,
  queriesToAdd,
  queryKeysToRemove
}: {
  router: NextRouter
  queriesToAdd?: { [key: string]: string }
  queryKeysToRemove?: string[]
}) => {
  const updatedQuery = { ...router.query }

  if (queryKeysToRemove)
    queryKeysToRemove.forEach((name: string) => {
      delete updatedQuery[name]
    })

  const newQuery = { ...updatedQuery, ...queriesToAdd }

  router.replace({ pathname: router.pathname, query: newQuery }, undefined, {
    shallow: true
  })
}
